<template>
  <q-btn-dropdown
    dense
    unelevated
    color="grey-4"
    text-color="black"
    :label="selectedJob?.title || 'Select Job'"
    class="rounded-borders q-pl-md text-caption justify-between"
  >
    <q-list v-if="jobs.length">
      <q-item
        :key="job.id"
        v-for="job in jobs"
        clickable
        v-close-popup
        @click="selectJob(job)"
      >
        <q-item-section>
          <q-item-label>{{ job.title }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
    <q-list v-else>
      <q-item>
        <q-item-section>
          <q-item-label>No Jobs Available</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { ApiRequest, SendError } from '@/helpers';
import { Sentry } from '@/vendors/Sentry';

const props = defineProps({
  integration: {
    type: String,
    required: true,
  },
  accountId: {
    type: String,
    default: null,
  },
  jobId: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['onSelect']);
const jobs = ref([]);
const selectedJob = ref(null);

const fetchJobs = async () => {
  if (!props.integration) {
    console.error('Integration not provided');
    return;
  }

  try {
    const response = await ApiRequest({
      method: 'get',
      url: `${import.meta.env.VITE_API_URL}/integrations/actions/jobs`,
      params: {
        integration: props.integration,
        accountId: props.accountId,
        jobId: props.jobId
      },
    });
    jobs.value = response.data.jobs;
  } catch (error) {
    Sentry.captureException(error);
    SendError(error);
    console.error('Error fetching jobs:', error);
  }
};

const selectJob = (job) => {
  selectedJob.value = job;
  emit('onSelect', {
    jobId: job.job?.id,
    visitId: job.visit?.id || job.id,
  });
};

onMounted(async () => {
  await fetchJobs();
});

watch(
  () => [props.integration, props.accountId, props.jobId],
  async () => {
    await fetchJobs();
  }
);
</script>
